<template>
    <v-card tile max-width="500" class="mx-auto" v-if="user">
        <v-card-actions>
            <v-btn text color="blue-grey" router :to="{ name: 'MyPage'}">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="ml-2">돌아가기</span>
            </v-btn>
        </v-card-actions>
        <v-img
        height="230px"
        src="/pen.jpg"
        >
            <v-row align="end" class="fill-height">
                <v-col align-self="start" class="pa-5" cols="12">
                    <v-avatar size="120">
                        <v-img :src="user.avatar"></v-img>
                    </v-avatar>
                </v-col>
                <v-col class="py-0">
                    <v-list-item dark class="white--text">
                        <v-list-item-content class="white--text pl-5" dark>
                            <v-list-item-title class="title" v-text="user.name"></v-list-item-title>
                            <v-list-item-subtitle v-text="user.alias"></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
            </v-row>
        </v-img>
        <v-card-title class="title blue-grey--text justify-center my-5">내 정보 고치기</v-card-title>
        <v-card-text>
            <v-form v-model="valid" ref="form">
                <v-text-field
                    type="password"
                    v-model="currentPassword"
                    label="현재 비밀번호"
                    :rules="passwordRules"
                    prepend-icon="mdi-textbox-password"
                    required>
                </v-text-field>
                <v-text-field
                    type="password"
                    v-model="password"
                    label="새 비밀번호"
                    :rules="passwordRules"
                    prepend-icon="mdi-textbox-password"
                    required>
                </v-text-field>
                <v-text-field
                    type="password"
                    v-model="passwordConfirm"
                    label="새 비밀번호 확인"
                    :rules="passwordConfirmRules"
                    prepend-icon="mdi-textbox-password"
                    required>
                </v-text-field>
                <v-text-field
                    v-model="user.name"
                    label="이름"
                    :rules="nameRules"
                    hint="ex) 홍길동"
                    prepend-icon="mdi-rename-box"
                    required>
                </v-text-field>
                <p class="text-center caption pink--text" v-if="feedback">{{ feedback }}</p>
                <v-select
                    prepend-icon="mdi-table-tennis"
                    v-model="user.type"
                    label="유형"
                    :items="types">                        
                </v-select>
                <v-row justify="center">
                    <v-btn :loading="loading" class="my-5 white--text" color="blue-grey accent-4" @click="modify" :disabled="!valid">변경하기</v-btn>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>  
</template>

<script>
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firebase-storage'

export default {
    name: 'EditProfile',
    data: () => ({
        user: null,
        loading: false,
        valid: false,
        feedback: null,
        types: ['펜홀더', '쉐이크 핸즈', '중펜', '기타'],
        currentPassword: '',
        password: '',
        passwordConfirm: '',
        passwordRules: [
            v => !!v || '비밀번호는 꼭 필요해요!',
            v => v.length >= 8 || '8자는 넘어야 해요!'
        ],
        passwordConfirmRules: [
            v => !!v || '비밀번호 확인이 필요해요!',
            v => v.length >= 8 || '8자는 넘어야 해요!'
        ],
        nameRules: [
            v => !!v || '이름은 꼭 필요해요!'
        ],
    }),
    methods: {
        modify(){
            if(this.password == this.passwordConfirm){
                this.loading = true
                db.collection('users').doc(this.user.id).update({
                    name: this.user.name,
                    type: this.user.type
                }).then(() => {

                    var user = firebase.auth().currentUser;
                    var credential = firebase.auth.EmailAuthProvider.credential(user.email, this.currentPassword);

                    // Prompt the user to re-provide their sign-in credentials
                    user.reauthenticateWithCredential(credential).then(() => {
                        // User re-authenticated.
                        console.log('cred')
                        // update the password
                        user.updatePassword(this.password).then(() => {
                            // Update successful.
                            console.log('Update successful')
                            this.loading = false;
                            this.$router.push({ name: "MyPage" })
                        }).catch(error => {
                            // An error happened.
                            this.feedback = error.message
                        });
                    }).catch(function(error) {
                        // An error happened.
                        this.feedback = error.message
                    });
                })
            } else {
                this.feedback = "비밀번호가 일치하지 않아요"
            }
        }
    },
    created(){
        let user = firebase.auth().currentUser;

        // get user
        if(user){
            db.collection('users').where('user_id', '==', user.uid).get().then(snapshot => {
                snapshot.forEach(doc => {
                    this.user = {
                        ...doc.data(),
                        id: doc.id
                    }
                })
            })
        }    
    }
};
</script>